import {inject, InjectionToken, NgZone} from '@angular/core';
import { BroadCastService } from './broadast.service';

export const BROADCAST_SERVICE = new InjectionToken<BroadCastService>('broadCastService', {
  factory: () => new BroadCastService(window.location.origin, inject(NgZone))
});
